'use client'
import { ShopifyCollection } from 'lib/shopify/types'
import { useEffect, useRef, useState } from 'react'
import { CollectionNavigation } from "views/shop/products/collection-navigation"
import { AddonItemBox } from "./addon-item-box"

interface ScrollableContentProps {
    addonCollections: ShopifyCollection[]
    sortedAddons: any[]
    discount: number
    productDiscounts: any[]
}

export function ScrollableContent({ addonCollections, sortedAddons, discount, productDiscounts }: ScrollableContentProps) {
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        // Set initial value
        handleResize();
        
        // Add event listener
        window.addEventListener('resize', handleResize);
        
        // Cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="flex flex-1 flex-col w-full overflow-hidden">
            <div className="pt-4 pb-5">
                <CollectionNavigation 
                    collections={addonCollections} 
                    scrollContainerRef={scrollContainerRef}
                    useContainerScroll={true}
                    style="dropdown"
                />
            </div>
            <div 
                ref={scrollContainerRef}
                className="overflow-y-auto lg:flex-1 scrollbar-hide"
            >
                {addonCollections && !!addonCollections.length && addonCollections.map(collection => {
                    return <div 
                        className={`md:mt-4 md:mb-10 transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] overflow-hidden md:block
                            ${isMobile ? 'max-h-0 opacity-0' : 'max-h-[2000px] opacity-100'}`}
                        key={collection.handle} 
                        id={collection.handle}
                        style={{
                            transitionProperty: 'max-height, opacity',
                            transitionDuration: '500ms, 400ms'
                        }}
                    >
                        <div className="transform transition-transform duration-500 ease-out">
                            <h3 className="text-2xl font-bold scroll-mt-[var(--navbar-height)]">{collection.title}</h3>
                            <p className="text-base text-gray-600 font-medium">{collection.description}</p>
                            <div>
                                <AddonItemBox 
                                    collectionHandle={collection.handle} 
                                    addons={sortedAddons} 
                                    discount={discount} 
                                    productDiscounts={productDiscounts}
                                />
                            </div>
                        </div>
                    </div>
                })}
            </div>
        </div>
    )
} 